import { Alert } from '@mui/material';

import { PageContainer, PageHeading } from '@/components/layout';

/**
 * DataSync/Lingk APIs Page
 *
 * This is a feature-gated page that provides:
 * - Data Sets (API credentials, usage stats, data summaries)
 * - Data Sharing (data feeds consumed/shared between projects)
 * - API Explorer (Swagger-style API documentation)
 * - Bulk Data Sync (bulk upload/download)
 * - Custom Properties (custom field management)
 *
 * Only visible to tenants with the "lingkapis" feature flag.
 *
 * Note: This feature is currently under development.
 * The blank page matches the production behavior for this feature-gated route.
 */
export const DataSyncPage = () => {
  return (
    <PageContainer>
      <PageHeading title="Lingk APIs" />
      <Alert severity="info" sx={{ mt: 2 }}>
        The Lingk APIs feature provides data management capabilities including Data Sets, Data
        Sharing, API Explorer, Bulk Data Sync, and Custom Properties.
        <br />
        <br />
        This feature is currently under development in the new UI. The full implementation will be
        available soon.
      </Alert>
    </PageContainer>
  );
};
